import styles from './ProgressBar.module.css';

export interface ProgressBarProps {
  /** 0-100. Values outside the range are clamped. */
  readonly value: number;
  readonly color?: string;
  readonly label?: string;
}

export function ProgressBar({ value, color = 'var(--aqua)', label }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      className={styles.track}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label ?? 'Progress'}
    >
      <div className={styles.fill} style={{ width: `${clamped}%`, background: color }} />
    </div>
  );
}
